import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import FundManagers from './FundManagers';
import getQueryResults from '../utils/query/getQueryResults';
import { DataStore, EntityStore } from '../stores';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import { FundManagers as FundManagersConfig } from '../models/configuration/components/FundManagers';
import { FundManagersOrchestrationConfig } from '../models/configuration/components/FundManagersOrchestration';

interface FundManagersOrchestrationProps {
    dataStore?: DataStore;
    entityStore?: EntityStore;
}

@inject('dataStore', 'entityStore')
@observer
class FundManagersOrchestration extends Component<
    FundManagersOrchestrationProps
> {
    constructor(props) {
        super(props);
    }

    @computed
    get config(): FundManagersOrchestrationConfig {
        return this.props.dataStore.config.rawRowConfig
            .fundManagersOrchestration;
    }

    @computed
    get fundManagersConfig(): FundManagersConfig {
        return this.props.dataStore.config.rawRowConfig.fundManagers;
    }

    @computed
    get fundManagerQueryData() {
        const { entityStore, dataStore } = this.props;
        if (entityStore?.value && this.config) {
            const query = this.config.data;
            const results = getQueryResults(
                entityStore.queryContext,
                { data: query },
                dataStore.culture
            );
            // Grouping based on the label
            if (results && results.data) {
                const keys = [];
                results.data = results.data.filter(row => {
                    const value = row[this.config.label];
                    if (keys.indexOf(value) === -1) {
                        keys.push(value);
                        return row;
                    }
                });
            }
            return results.data;
        }
    }

    orchestratedFundManagerProps(data) {
        const { dataStore } = this.props;

        if (this.config && this.fundManagersConfig) {
            const newFundManagerConfig = { ...this.fundManagersConfig };
            const label = data[this.config.label] || '';
            const name = data[this.config.name] || '';
            let imageSrc = '';

            if (this.config.imageSrc) {
                const imageSrcKey = data[this.config.imageSrc.key];
                imageSrc = replacePlaceholders({
                    values: { key: imageSrcKey },
                    text: this.config.imageSrc.placeholder,
                });
            }
            newFundManagerConfig.label = label;
            const fundManagerProps = {
                fundManagers: [
                    {
                        code: label,
                        name,
                    },
                ],
                overrideConfig: newFundManagerConfig,
                imageSrc,
                showHeading: true,
                isMobile: dataStore.isMobile,
            };
            return fundManagerProps;
        }
        return {};
    }

    @computed
    get fundManagerComponent() {
        const data = this.fundManagerQueryData;
        if (data) {
            return data.map((elem, idx) => {
                const props = this.orchestratedFundManagerProps(elem);
                return <FundManagers key={`${elem.label}${idx}`} {...props} />;
            });
        }
        return null;
    }

    render() {
        const { fundManagerComponent } = this;
        if (isNullOrEmpty(fundManagerComponent)) {
            return null;
        }
        return fundManagerComponent;
    }
}

export default withTheme(FundManagersOrchestration) as any;



// WEBPACK FOOTER //
// ./src/Components/FundManagersOrchestration.tsx